import React from 'react'
import { Scatter } from 'react-chartjs-2'
import Variables from '../../../../../javascript/stylesheets/variables.module.scss'
import { WithErrorBoundary } from '../../../errorboundary/ErrorBoundaryProvider'
import I18n from 'i18n'
import { zipData } from '../../../common/Utils'
import {
  chartjsDefaultArguments,
  chartjsDefaultOptions,
  chartjsScaleLabelProperties,
  chartjsTitleProperties
} from '../../../common/Constants'
const { primaryColor, accentColor } = Variables

/**
 * Renders a scatter plot for the given x and y datasets. Also adds a linear regression line
 * A slider is rendered above the plot to control the number of samples that are shown.
 */
const ScatterPlot = ({ xs, ys, xLabel = 'X', yLabel = 'Y', title = 'Scatterplot', height = 250, showLegend = false, xTickCallback = (v) => v, fit = [], fitLabel = 'Regression' }) => {
  /**
   * render both the scatterplot and regression line
   */
  const chartData = {
    labels: xs,
    datasets: [
      {
        type: 'scatter',
        yAxisID: 'y-axis-1',
        fill: false,
        label: `${xLabel} - ${yLabel}`,
        backgroundColor: primaryColor,
        borderColor: primaryColor,
        borderWidth: 1,
        data: zipData(xs, ys),
        order: 1
      }
    ]
  }

  if (fit.length) {
    chartData.datasets.unshift({
      type: 'line',
      yAxisID: 'y-axis-1',
      label: fitLabel,
      data: fit,
      fill: false,
      backgroundColor: accentColor,
      borderColor: accentColor,
      pointRadius: 0
    })
  }

  /**
   * Styling options for the scatterplot
   */
  const options = {
    ...chartjsDefaultOptions,
    maintainAspectRatio: false,
    responsive: true,
    elements: {
      line: {
        fill: false
      }
    },
    plugins: {
      title: {
        ...chartjsTitleProperties,
        display: true,
        text: title
      },
      tooltip: {
        mode: 'index'
      },
      legend: { display: showLegend }
    },
    scales: {
      x: {
        type: 'linear',
        display: true,
        grid: {
          display: false
        },
        title: {
          display: true,
          text: xLabel
        },
        ticks: {
          callback: xTickCallback
        }
      },
      'y-axis-1': {
        type: 'linear',
        display: true,
        position: 'left',
        grid: {
          display: true
        },
        title: {
          ...chartjsScaleLabelProperties,
          display: true,
          text: yLabel
        }
      }
    }
  }

  return (
    <Scatter {...chartjsDefaultArguments} height={height} data={chartData} options={options} />
  )
}

export default WithErrorBoundary(ScatterPlot, I18n.t('components.visualization.scatterplot.error'))
